var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technology/folder/closed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66663 8.33337H18.3333M1.66663 15V5.00004C1.66663 4.07957 2.41282 3.33337 3.33329 3.33337H5.97627C6.4183 3.33337 6.84222 3.50897 7.15478 3.82153L7.84514 4.51189C8.1577 4.82445 8.58162 5.00004 9.02365 5.00004H16.6666C17.5871 5.00004 18.3333 5.74623 18.3333 6.66671V15C18.3333 15.9205 17.5871 16.6667 16.6666 16.6667H3.33329C2.41282 16.6667 1.66663 15.9205 1.66663 15Z",
    stroke: "#026735",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.781a898440e98c0ac24e1a4b6a29b149.svg";
export { ForwardRef as ReactComponent };